import React, { useState, useEffect, useRef } from "react";
import classnames from "classnames";
import NumberFormat from "react-number-format";
import Skeleton from "react-loading-skeleton";
import axiosInstance from "./../../helpers/axiosInstance";
import MyModal from "components/Modal/Modal";
import santander from '../../assets/img/brand/santander.png';
import exitoCreacion from '../../assets/img/illustrations/add-contact-success.svg';
import ComponentemodificaUsu from './modificaUsuario.js'


// reactstrap components
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  Modal,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  CardHeader,
  Button,
  FormGroup,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { normalizeUnits } from "moment";
import { tr } from "date-fns/locale";
import basePerfiles from "./basePerfiles.js";
import baseUsuarios from "./baseUsu.js";
import { set } from "date-fns";
import baseTransaccionPen from "./baseTransaccionesPen.js";
import IconUnCheck from '../../assets/img/icons/Check-01_Idea.png';
import IconCheck from '../../assets/img/icons/Check-02_Idea.png';
import { useDispatch, useSelector } from "react-redux";
import { actualizarCheckboxs } from "Silicerreducerpayu";

const Checksantader=(props)=>{
  const dispatcher = useDispatch()
  const listCheckbox = useSelector((state) => state.pagopayu.checkboxPago)
  const [mensaje,setmensaje]=useState(props.mensaje);
  const [estadocheck,setestadocheck]=useState(props.estadocheck);
  const [idcheck,setidcheck]=useState(props.idCheck);
  const [iconocheck,seticonocheck]=useState(false);
  const [permisocambio,setpermisocambio]=useState(props.permisocambio);
  useEffect(()=>{
    console.log("se ejecuta UseEffect");
    setestadocheck(props.estadocheck);
    if(props.estadocheck){
      seticonocheck(IconCheck);
    }else{
      seticonocheck(IconUnCheck);
    }
  },[props.estadocheck]);
  const clicCheck=()=>{
    if(props.permisocambio){
      if(estadocheck){
        setestadocheck(false);
        dispatcher(actualizarCheckboxs([true, true, true]) )
        seticonocheck(IconUnCheck);
        if(props.funcionpadre){
          props.funcionpadre(idcheck,false);
        }
      }else{
        setestadocheck(true);
        let checboxTemp = []
        listCheckbox.map((item, index) => {
            if (index == props.idCheck){
                checboxTemp.push(true)
            }
            else{
              checboxTemp.push(false)
            }
        })
        dispatcher(actualizarCheckboxs(checboxTemp) )
        seticonocheck(IconCheck);
        if(props.funcionpadre){
          props.funcionpadre(idcheck,true);
        }
      }
    }
  }
  return(
    <div style={{margin:"5px 5px 5px 5px",display:"flex",flexDirection:"row",justifyContent:"flex-start", gap:"4px"}}>
      <img style={{height:"25px",margin:"6px 2px"}} src={iconocheck} onClick={clicCheck}></img>
      <p style={{display:"inline",fontSize:"15px", margin:"2px 2px 2px 2px"}}>{mensaje}</p>
    </div>
  )

}
Checksantader.defaultProps={
  permisocambio:true

};

export default Checksantader;